import httpClient from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getUpgradeConfigWithPurchaseMotionsRpc } from 'upgrade-management-service-types';
import { trackUpgradeBannerFailure } from '../_core/utils/metricUtils';
import { UPGRADE_BANNER_TYPES } from '../ums/types';
import { warnArchivedUpgradePointUse } from '../ums/utils';
const rpcClient = createRpcClientV2({
  hubHttpClient: httpClient
});
export const useFetchUpgradeBannerConfig = (upgradeKey, limit, usage) => {
  const [fetchedBannerDetails, setFetchedBannerDetails] = useState({
    loading: true,
    error: null
  });
  useEffect(() => {
    if (!upgradeKey || upgradeKey === '') {
      setFetchedBannerDetails({
        loading: false,
        error: new Error('Upgrade key is empty')
      });
      return;
    }
    rpcClient.call(getUpgradeConfigWithPurchaseMotionsRpc, {
      pathParameters: {
        upgradeKey
      },
      queryParameters: {
        limit,
        amountUsed: usage
      }
    }).then(upgradePointResponse => {
      if (!upgradePointResponse) return;
      if (!Object.keys(UPGRADE_BANNER_TYPES).includes(upgradePointResponse.pointType)) {
        throw new Error(`(UIUpgradeBanner) - ${upgradeKey} was declared with an incompatible point type "${upgradePointResponse.pointType}"`);
      }
      setFetchedBannerDetails({
        loading: false,
        error: null,
        data: {
          upgradeConfig: upgradePointResponse
        }
      });
      if (upgradePointResponse.status === 'ARCHIVED') {
        warnArchivedUpgradePointUse(upgradePointResponse.upgradeKey);
      }
    }).catch(error => {
      var _error$cause;
      // 0 indicates user aborted requests, which we don't want to log as errors
      if (((_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.status) !== 0) {
        var _error$cause2, _error$cause3, _error$cause4;
        const message = ((_error$cause2 = error.cause) === null || _error$cause2 === void 0 ? void 0 : _error$cause2.status) === 404 ? `${upgradeKey}: upgrade point may not exist in the UMS.` : `${upgradeKey}: unexpected error fetching upgrade banner config`;
        Raven.captureException(new Error(message, {
          cause: error.cause
        }), {
          extra: {
            upgradeKey,
            limit,
            usage,
            status: (_error$cause3 = error.cause) === null || _error$cause3 === void 0 ? void 0 : _error$cause3.status,
            errorCode: (_error$cause4 = error.cause) === null || _error$cause4 === void 0 ? void 0 : _error$cause4.errorCode
          },
          fingerprint: ['use-fetch-upgrade-banner-config']
        });
        trackUpgradeBannerFailure(upgradeKey);
      }
      setFetchedBannerDetails({
        loading: false,
        error
      });
    });
  }, [upgradeKey, limit, usage]);
  return fetchedBannerDetails;
};